export const SKILL_COURSE_MAPPING_SERIES = ['skills', 'unmapped'];
